import request from '../../utils/requests'

/**
 * Tag: Insurance
 */

const baseUrl = "/api/orgInsuranceSettings";


/**
 * 机构已绑定的保险
 * @param {*} body
 * {
 *    reqs Desc: Required:true
 * }
 */
async function _orgInsuranceBinded(body) {
  return request(baseUrl + '/OrgInsuranceBinded', {
    method: 'POST',
    body: body,
  });
}

/**
 * 获取绑定的机+校区的投保人信息
 * @param {*} body
 * {
 *    reqs Desc: Required:true
 * }
 */
async function _getOrgInsuranceBindedInfo(body) {
  return request(baseUrl + '/GetOrgInsuranceBindedInfo', {
    method: 'POST',
    body: body,
  });
}

/**
 * 分页获取投保的学生列表
 * @param {*} body
 * {
 *    reqs Desc: Required:true
 * }
 */
async function _getOrgInsuranceStudentInfo(body) {
  return request(baseUrl + '/GetOrgInsuranceStudentInfo', {
    method: 'POST',
    body: body,
  });
}

/**
 * 投保验证
 * @param {*} body
 * {
 *    reqs Desc: Required:true
 * }
 */
async function _orgInsuranceValid(body) {
  return request(baseUrl + '/OrgInsuranceValid', {
    method: 'POST',
    body: body,
  });
}


/**
 * 投保
 * @param {*} body
 * {
 *    reqs Desc: Required:true
 * }
 */
async function _orgInsurance(body) {
  return request(baseUrl + '/OrgInsurance', {
    method: 'POST',
    body: body,
  });
}



/**
 * 获取校区关联保险分页查询
 * @param {*} body
 * {
 *    reqs Desc: Required:true
 * }
 */
async function _getOrgInsuranceInfo(body) {
  return request(baseUrl + '/getOrgInsuranceInfo', {
    method: 'POST',
    body: body,
  });

}

/**
 * 更新机构投保资料
 * @param {*} body
 * {
 *    reqs Desc: Required:true
 * }
 */
async function _saveOrgInsuranceSettings(body) {
  return request(baseUrl + '/saveOrgInsuranceSettings', {
    method: 'POST',
    body: body,
  });
}


/**
 * 绑定校区投保资料
 * @param {*} body
 * {
 *    reqs Desc: Required:true
 * }
 */
async function _saveOrgBranchInsuranceSettings(body) {
  return request(baseUrl + '/saveOrgBranchInsuranceSettings', {
    method: 'POST',
    body: body,
  });

}

/**
 * 获取机构投保周期列表
 * @param {*} body
 * {
 *    reqs Desc: Required:true
 * }
 */
async function _orgInsuranceCycle(body) {
  return request(baseUrl + '/orgInsuranceCycle', {
    method: 'POST',
    body: body,
  });
}


/**
 * 获取机构已绑定的保险
 * @param {*} body
 * {
 *    reqs Desc: Required:true
 * }
 */
async function _getOrgInsuranceStatisticsInfo(body) {
  return request(baseUrl + '/GetOrgInsuranceStatisticsInfo', {
    method: 'POST',
    body: body,
  });
}



/**
 * 获取在保学生的详细信息
 * @param {*} body
 * {
 *    reqs Desc: Required:true
 * }
 */
async function _getOrgInsuranceStudentDetail(body) {
  return request(baseUrl + '/GetOrgInsuranceStudentDetail', {
    method: 'POST',
    body: body,
  });
}



/**
 * 获取在保学生的列表
 * @param {*} body
 * {
 *    reqs Desc: Required:true
 * }
 */
async function _getOrgInsuranceStudentList(body) {
  return request(baseUrl + '/GetOrgInsuranceStudentList', {
    method: 'POST',
    body: body,
  });
}


export default {
  _getOrgInsuranceInfo,
  _saveOrgInsuranceSettings,
  _saveOrgBranchInsuranceSettings,
  _orgInsuranceBinded,
  _getOrgInsuranceBindedInfo,
  _getOrgInsuranceStudentInfo,
  _orgInsuranceValid,
  _orgInsurance,
  _orgInsuranceCycle,
  _getOrgInsuranceStatisticsInfo,
  _getOrgInsuranceStudentDetail,
  _getOrgInsuranceStudentList
}




// WEBPACK FOOTER //
// ./src/services/orgInsuranceSettings.js